module.exports = __webpack_public_path__ + "uploadPrivatePortfolios.cee0b3105dfff1a5e62fd851088d8304.svg";